import notificationService from './notificationService'
import { notificationTypes } from '../components/Default/NotificationCenter/constants'
import { countRoomsWithoutImages } from './roomImagesRules'

// Single writer of the rooms-without-images notification. Driven by the
// property's rooms and image galleries (from PropertyPage), so it follows image
// assignments as well as rooms being added or removed.
const NOTIFICATION_ID = 'rooms-without-images'

let lastSignature = null

/**
 * Counts the rooms without images and pushes/dismisses the rooms-without-images
 * notification accordingly.
 *
 * Guards on a signature of the counts so re-running with unchanged counts is a
 * no-op (the notification isn't needlessly re-pushed / re-marked unread).
 *
 * @param {Array<{ id: string }>} rooms the property's rooms
 * @param {{ rooms: Object }} galleries the property's image galleries
 */
export const syncRoomImagesNotification = (rooms, galleries) => {
  const { missing, total } = countRoomsWithoutImages(rooms, galleries?.rooms)
  const signature = `${missing}|${total}`

  if (signature === lastSignature) {
    return
  }
  lastSignature = signature

  if (missing > 0) {
    notificationService.push({
      id: NOTIFICATION_ID,
      type: notificationTypes.ROOMS_WITHOUT_IMAGES,
      payload: { missing, total },
    })
  } else {
    notificationService.dismiss(NOTIFICATION_ID)
  }
}

/**
 * Clears the notification and the signature tracker — call when leaving a
 * property or switching to another one, so the next property re-emits its own
 * state.
 */
export const resetRoomImagesNotification = () => {
  lastSignature = null
  notificationService.dismiss(NOTIFICATION_ID)
}
